/**
 * EditPaidPartnerProductCtrl controller
 */

/**
 * EditPaidPartnerProductCtrl controller
 *
 * @class EditPaidPartnerProductCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:EditPaidPartnerProductCtrl
 */
/* @ngInject */
export default function EditPaidPartnerProductCtrl ($scope, $location, $uibModalInstance, NetworkCurrency, authSvc, pp, subscription) {
  var vm = this
  vm.pp = pp
  vm.subscription = subscription

  vm.hasFlag = function (flag) {
    return authSvc.hasEnabledFlag(flag)
  }

  /**
   * Table state for pageable request
   *
   * @memberof mwApp/packages.controller:AddAddonsCtrl
   */
  vm.initTableState = {
    page: 0,
    count: 1000,
    last: false
  }

  vm.tableState = angular.copy(vm.initTableState)

  /**
   * Create or edit coupon, and close modal window afterwards
   *
   * @memberof mwApp/packages.controller:EditPaidPartnerProductCtrl
   */
  vm.submit = function () {
    vm.pp.monetization.subscriptionId = vm.subscription.id
    vm.pp.monetization.type = 'PAID'
    $uibModalInstance.close()
  }

  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }
}
